import { DataLabel } from '@fourthwall/module-analytics';
import { pluralize } from '@fourthwall/utils/dist/string';
import React from 'react';
export const mapConversionRatesAggregatedValueToAnalyticsRows = (data) => {
    if (!data)
        return [];
    const getDescription = (value) => `${value} ${pluralize(value, 'session')}`;
    return [
        {
            label: (React.createElement(DataLabel, { label: "Added to cart", description: getDescription(data.cartCreated.value) })),
            value: `${data.cartCreated.percentage}%`,
        },
        {
            label: (React.createElement(DataLabel, { label: "Checkout started", description: getDescription(data.checkoutCreated.value) })),
            value: `${data.checkoutCreated.percentage}%`,
        },
        {
            label: (React.createElement(DataLabel, { label: "Successful checkout", description: getDescription(data.checkoutPaid.value) })),
            value: `${data.checkoutPaid.percentage}%`,
        },
    ];
};
